import { FormulaireInterface } from '../../types/Exa_Formulaire'
import { InputInterface, TypeInput } from '../../types/Exa_Input'
import { PartieFormulaireInterface, TypePartie } from '../../types/Exa_PartieFormulaire'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const namespaced = true


export const state: FormulaireInterface = {
    libelle:'',
    parties: [],
    partieSelect: null,
    json: '',
    jsonValues: '',
    tempPartieId: null,
    description: '',
    documents: null
}

export const mutations = {
    RESET_STATE (state: FormulaireInterface) {
        Object.assign(state, {
            type: TypePartie.TYPE_MANUEL,
            libelle: '',
            description: '',
            parties: [],
            partieSelect: null,
            json: '',
            jsonValues: '',
            tempPartieId: null,
            data: null,
            documents: null
        })
    },
    SET_PARTIES (state: FormulaireInterface, parties: Array<PartieFormulaireInterface>) {
        state.parties = parties
    },
    SET_LIBELLE (state: FormulaireInterface, libelle: string) {
        state.libelle = libelle
    },
    SET_DESCRIPTION (state: FormulaireInterface, description: string) {
        state.description = description !== null ? description : ''
    },
    SET_PARTIE_SELECT(state: FormulaireInterface, partieFormulaire: PartieFormulaireInterface) {
        state.partieSelect = partieFormulaire
    },
    SAVE_PARTIE_SELECT(state: FormulaireInterface) {
        if (state.partieSelect) {
            if (Number(state.partieSelect.id) !== 0) {
                for (let i = 0; i < state.parties.length; i++) {
                    if (Number(state.parties[i].id) === Number(state.partieSelect.id)) {
                        state.parties[i] = state.partieSelect
                        state.tempPartieId = state.partieSelect.id
                    }
                }
            } else {
                if (Number(state.partieSelect.id) === 0) {
                    let idTemp = 1
                    for (let j = 0; j < state.parties.length; j++) {
                        if (Number(state.parties[j].id) >= idTemp) {
                            idTemp = state.parties[j].id + 1
                        }
                    }
                    state.partieSelect.id = idTemp;                        
                    (state.parties as Array<PartieFormulaireInterface>).push(state.partieSelect)
                    state.tempPartieId = idTemp
                }
            }          
        }
    },
    REMOVE_PARTIE_SELECT(state: FormulaireInterface) {
        if (state.partieSelect) {
            const partiesTemp: Array<PartieFormulaireInterface> = []
            for (let i = 0; i < state.parties.length; i++) {
                if (Number(state.parties[i].id) !== Number(state.partieSelect.id)) {
                    partiesTemp.push(state.parties[i])
                }
            }
            for (let j = 0; j < partiesTemp.length; j++) {
                partiesTemp[j].ordre = j
            }
            state.parties = partiesTemp
            state.partieSelect = null
        }
    },
    REMOVE_PARTIE_BY_ID(state: FormulaireInterface, partie_id: number) {
        const partiesTemp: Array<PartieFormulaireInterface> = []
        for (let i = 0; i < state.parties.length; i++) {
            if (Number(state.parties[i].id) !== Number(partie_id)) {
                partiesTemp.push(state.parties[i])
            }
        }
        for (let j = 0; j < partiesTemp.length; j++) {
            partiesTemp[j].ordre = j
        }
        state.parties = partiesTemp
    },
    ADD_PARTIE(state: FormulaireInterface, newPartie: PartieFormulaireInterface) {
        newPartie.ordre = state.parties.length
        state.partieSelect = newPartie
    },
    SET_ORDER_PARTIES(state: FormulaireInterface, data: any) {
        const partieTemp = state.parties.filter((partieTmp: PartieFormulaireInterface) => Number(partieTmp.id) === Number(state.tempPartieId))[0]
        if (partieTemp) {
            const partiesTemp = []
            for (let i = 0; i < state.parties.length; i++) {
                if (Number(state.parties[i].id) !== Number(partieTemp.id) && Number(state.parties[i].id) !== Number(data.markedPartieId)) {
                    state.parties[i].ordre = Number(partiesTemp.length)
                    partiesTemp.push(state.parties[i])
                } else if (Number(state.parties[i].id) === Number(data.markedPartieId)) {
                    if (data.way === 'before') {
                        partieTemp.ordre = Number(partiesTemp.length)
                        partiesTemp.push(partieTemp)
                        state.parties[i].ordre = Number(partiesTemp.length)
                        partiesTemp.push(state.parties[i])
                    } else if (data.way === 'after') {
                        state.parties[i].ordre = Number(partiesTemp.length)
                        partiesTemp.push(state.parties[i])
                        partieTemp.ordre = Number(partiesTemp.length)
                        partiesTemp.push(partieTemp)
                    }
                } else if (Number(state.parties.length) === 1) {
                    partiesTemp.push(partieTemp)
                }
            }
            partiesTemp.sort((a: PartieFormulaireInterface, b: PartieFormulaireInterface) => Number(a.ordre) > Number(b.ordre) ? 1 : (Number(a.ordre) < Number(b.ordre) ? -1 : 0))
            state.parties = []
            state.parties = partiesTemp
        }
    },
    UPDATE_JSON(state: FormulaireInterface) {
        const parties = []
        for (let i = 0; i < state.parties.length; i++) {
            parties.push({
                id: state.parties[i].id,
                ref: state.parties[i].ref,
                type: state.parties[i].type,
                libelle: state.parties[i].libelle,
                description: state.parties[i].description,
                ordre: Number(state.parties[i].ordre),
                inputs: JSON.parse(JSON.stringify(state.parties[i].inputs)),
                condition: state.parties[i].condition,
                data: state.parties[i].data
            })
            for (let j = 0; j < parties[i].inputs.length; j++) {
                parties[i].inputs[j].value = null
                parties[i].inputs[j].anomalie = null
            }
        }
        state.json = JSON.stringify({
            libelle: state.libelle,
            description: state.description,
            parties: parties
        })
    },
    UPDATE_JSON_VALUES(state: FormulaireInterface) {
        const parties = []
        const allValues = []
        state.documents = []
        for (let i = 0; i < state.parties.length; i++) {
            const values: Array<any> = []
            if (Number(state.parties[i].type) === TypePartie.TYPE_AUTO) {
                let val: Array<any> = []
                if (state.parties[i].value) {
                    for (let j = 0; j < state.parties[i].value.length; j++) {
                        val = val.concat(state.parties[i].value[j].value)
                    }
                }
                values.push({
                    id: state.parties[i].id,
                    ref: state.parties[i].ref,
                    fullValue: state.parties[i].value,
                    value:val
                })
                allValues.push({
                    type: 'partie',
                    ref: state.parties[i].ref,
                    id: state.parties[i].id,
                    fullValue: state.parties[i].value,
                    value:val
                })
            } else {
                for (let j = 0; j < state.parties[i].inputs.length; j++) {
                    const input = {
                        type: 'input',
                        ref: state.parties[i].inputs[j].ref,
                        id: state.parties[i].inputs[j].id,
                        value: state.parties[i].inputs[j].value
                    }
                    if (state.parties[i].inputs[j].type === TypeInput.TYPE_FILE && state.parties[i].inputs[j].value != null) {
                        for (let k = 0; k < input.value.length; k++) {
                            if (input.value[k].id !== null) {
                                input.value[k].data = null
                            }
                        }
                        state.documents.push({
                            input_id: state.parties[i].inputs[j].id,
                            partie: (state.parties[i].ordre + 1) + '. ' + state.parties[i].libelle,
                            input: '#' + (state.parties[i].inputs[j].ordre + 1) + ' ' + state.parties[i].inputs[j].libelle,
                            files: state.parties[i].inputs[j].value
                        })
                    }
                    values.push(input)  
                    allValues.push(input)
                }
            }
            const partie: any = {
                id: state.parties[i].id,
                values:values
            }
            parties.push(partie)
        }
        state.jsonValues = JSON.stringify(
            // parties: parties
            allValues
        )
    },
    SET_VALUES(state: FormulaireInterface, data: any) {
        if (data === null) {
            const parties = []
            for (let i = 0; i < state.parties.length; i++) {
                const values: Array<any> = []
                for (let j = 0; j < state.parties[i].inputs.length; j++) {
                    const input = {
                        id: state.parties[i].inputs[j].id,
                        ref: state.parties[i].inputs[j].ref,
                        value: null
                    }
                    values.push(input)             
                }
                const partie: any = {
                    id: state.parties[i].id,
                    ref: state.parties[i].ref,
                    values:values
                }
                parties.push(partie)
            }
            data = {
                parties: parties
            }
        }
        let inputs: Array<InputInterface> = []
        for (let i = 0; i < state.parties.length; i++) {
            inputs = inputs.concat(state.parties[i].inputs)
        }
        for (const i in data) {
            if (data[i]) {
                if (data[i].type === 'partie') {
                    const pt: any = state.parties.find((partieTemp: PartieFormulaireInterface) => Number(partieTemp.id) === Number(data[i].id))
                    if (pt) {
                        pt.value = data[i].fullValue                    
                    }
                } else {
                    const inputTemp: any = inputs.find((inputTmp: InputInterface) => Number(inputTmp.id) === Number(data[i].id))
                    if (inputTemp) {
                        inputTemp.value = data[i].value                    
                    }
                }
            }
        }
    } 
}

export const actions = {
    loadFormulaire({ commit }: { commit: any }, formulaire: FormulaireInterface) {
        if (formulaire === null) {
            formulaire = {
                libelle: '',
                description: '',
                parties: []
            }
        }
        commit('SET_PARTIES', formulaire.parties)
        commit('SET_LIBELLE', formulaire.libelle)
        commit('SET_DESCRIPTION', formulaire.description)
        commit('UPDATE_JSON')
    },
    setLibelle({ commit }: { commit: any }, libelle: string) {
        commit('SET_LIBELLE', libelle)
    },
    setDescription({ commit }: { commit: any }, description: string) {
        commit('SET_DESCRIPTION', description)
    },
    setPartieSelect({ commit }: { commit: any }, partieFormulaire: PartieFormulaireInterface) {
        commit('SET_PARTIE_SELECT', JSON.parse(JSON.stringify(partieFormulaire)))
    },
    savePartieSelect({ commit }: { commit: any }) {
        commit('SAVE_PARTIE_SELECT')
        commit('UPDATE_JSON')
    },
    removePartieSelect({ commit }: { commit: any }) {
        commit('REMOVE_PARTIE_SELECT')
        commit('UPDATE_JSON')
    },
    removePartieById({ commit }: { commit: any }, partieFormulaire_id: number) {
        commit('REMOVE_PARTIE_BY_ID', partieFormulaire_id)
        commit('UPDATE_JSON')
    },
    addPartie({ commit }: { commit: any }) {
        const newPartie: PartieFormulaireInterface = {
            type: TypePartie.TYPE_MANUEL,
            ref: '',
            id: 0,
            libelle: '',
            ordre: 0,
            inputs: [],
            inputSelect: null,
            condition: null,
            description: '',
            data: null,
            value: null
        }
        commit('ADD_PARTIE', newPartie)
        commit('UPDATE_JSON')
    },
    setOrderParties({ commit }: { commit: any }, data: any) {
        commit('SET_ORDER_PARTIES', data)
    },
    updateJson({ commit }: { commit: any }) {
        commit('UPDATE_JSON')
    },
    updateJsonValues({ commit }: { commit: any }) {
        commit('UPDATE_JSON_VALUES')
    },
    setValues({ commit }: { commit: any }, data: any) {
        commit('SET_VALUES', data)
    }
}

export const getters = {
    parties: (state: FormulaireInterface) => {
        return state.parties
    },
    libelle: (state: FormulaireInterface) => {
        return state.libelle
    },
    description: (state: FormulaireInterface) => {
        return state.description
    },
    partieSelect: (state: FormulaireInterface) => {
        return state.partieSelect
    },
    getJson: (state: FormulaireInterface) => {
        return state.json
    },
    getJsonValues: (state: FormulaireInterface) => {
        return state.jsonValues
    },
    getInputByIdAndPartieId: (state: FormulaireInterface) => (input_id: number, partieId: number) => {
        const partieTemp = state.parties.find((partieTmp: PartieFormulaireInterface) => Number(partieTmp.id) === Number(partieId))
        return partieTemp?.inputs.find((inputTmp: InputInterface) => Number(inputTmp.id) === Number(input_id))
    },
    inputs: (state: FormulaireInterface) => (partie_id: number | null = null) => { 
        let inputs: Array<InputInterface> = []
        for (let i = 0; i < state.parties.length; i++) {
            if (partie_id === null || partie_id !== state.parties[i].id) {
                inputs = inputs.concat(state.parties[i].inputs)
            }
        }
        return inputs
    },
    getInputById: (state: FormulaireInterface) => (input_id: number) => {
        let inputs: Array<InputInterface> = []
        for (let i = 0; i < state.parties.length; i++) {
            inputs = inputs.concat(state.parties[i].inputs)
        }
        return inputs.find((inputTmp: InputInterface) =>  Number(inputTmp.id) === Number(input_id))
    },
    getNextInputId: (state: FormulaireInterface) => {
        let biggestId = 1
        for (let i = 0; i < state.parties.length; i++) {
            for (let j = 0; j < state.parties[i].inputs.length; j++) {
                if (Number(state.parties[i].inputs[j].id) >= Number(biggestId)) {
                    biggestId = Number(state.parties[i].inputs[j].id) + 1
                }
            }
        }
        return biggestId
    },
    InputIsConditionForAnotherInput: (state: FormulaireInterface) => (input_id: number) => {
        let retourp = ''
        let retourc = ''
        for (let i = 0; i < state.parties.length; i++) {
            if (state.parties[i].condition && Number(state.parties[i].condition.champ_id) === Number(input_id)) {
                if (retourp !== '') {
                    retourp += ', '
                }
                retourp += '#' + (state.parties[i].ordre + 1)
            }
            for (let j = 0; j < state.parties[i].inputs.length; j++) {
                if (state.parties[i].inputs[j].condition && Number(state.parties[i].inputs[j].condition.champ_id) === Number(input_id)) {
                    if (retourc !== '') {
                        retourc += ', '
                    }
                    retourc += '#' + (state.parties[i].ordre + 1) + '.' + (state.parties[i].inputs[j].ordre + 1)
                }
            }
        }
        const expression = /(.*),(.*)/
        if (retourc !== '' || retourp !== '') {
            let retour = 'Est utilisé comme condition '
            if (retourp !== '') {
                if (retourp.includes(',')) {
                    retour += 'pour les parties ' + retourp.replace(expression, '$1 et $2')
                } else {
                    retour += 'pour la partie ' + retourp
                }
            }
            if (retourc !== '') {
                if (retour !== '') {
                    retour += ' et '
                }
                if (retourc.includes(',')) {
                    retour += 'pour les champs ' + retourc.replace(expression, '$1 et $2')
                } else {
                    retour += 'pour le champ ' + retourc
                }
            }
            return retour
        } else {
            return false
        }
    },
    isSelectedInPartieAuto:  (state: FormulaireInterface) => (cle: string, value: any) => {
        for (let i = 0; i < state.parties.length; i++) {
            if (Number(state.parties[i].type) === TypePartie.TYPE_AUTO && state.parties[i].value && state.parties[i].value.length > 0) {
                for (let j = 0; j < state.parties[i].value.length; j++) {
                    if (state.parties[i].value[j].cle === cle && state.parties[i].value[j].value.includes(value)) {
                        return true
                    }
                }
            }
        }
        return false
    },
    isRefIsUnique: (state: FormulaireInterface) => (ref: string, fromId: any) => {
        for (let i = 0; i < state.parties.length; i++) {
            if (state.parties[i].ref === ref && state.parties[i].id !== fromId) {
                return false
            }
            for (let j = 0; j < state.parties[i].inputs.length; j++) {
                if (state.parties[i].inputs[j].ref === ref &&  state.parties[i].inputs[j].id !== fromId) {
                    return false
                }
            }
        }
        return true
    },
    partiesAutomatiques: (state: FormulaireInterface) => {
        const retour = []
        for (let i = 0; i < state.parties.length; i++) {
            if (state.parties[i].type === TypePartie.TYPE_AUTO) {
                retour.push(state.parties[i])
            }
        }
        return retour
    },
    inputsOfPartieHaveConditions: (state: FormulaireInterface) => (partie_id: number, input_ident: number) => {
        const partieTemp = state.parties.find((partieTmp: PartieFormulaireInterface) => Number(partieTmp.id) === Number(partie_id))
        const inputsWithCondition: Array<InputInterface> | undefined = partieTemp?.inputs.filter((inputTmp: InputInterface) => inputTmp.condition !== null && Number(inputTmp.condition.champ_id) === Number(input_ident))
        if (inputsWithCondition !== undefined && inputsWithCondition.length > 0) {
            return inputsWithCondition[0]
        }
    },
    documents: (state: FormulaireInterface) => {
        return state.documents
    }
}
